import { CarouselWithDefault } from "./CarouselWithDefault";

type StringExamplesCarouselParams = {
    examples: string[];
};
export function StringExamplesCarousel({ examples }: StringExamplesCarouselParams) {
    // Guard against Contentful entries authored with a string-examples render type but empty
    // examples — CarouselWithDefault would fall through to ChecklistExampleDefaultState with
    // no props and render a bare Loader.
    if (examples.length === 0) return null;
    const checklistItemExamples = examples.map((text) => ({ text }));

    return <CarouselWithDefault examples={checklistItemExamples} />;
}
